/* eslint-disable */

import Vue from 'vue';
import Vuex from 'vuex';

import layout from './layout';
import customer from './customer';
import tasks from './tasks';
import lists from './lists';
import alert from './alert';
import filters from './filters';
import teamio from './teamio';
import wiki from './wiki';
//import socket from './socket';
import notifications from './notifications';
import checklists from './checklists';
import routines from './routines';
import superadmin from './superadmin';
import chat from './chat';
import workflow from './workflow';
import huddle from './huddle';
import conversationsV2 from './conversationsV2';
import taskNotifications from './taskNotifications';

import forms from './forms';
import aptreminder from './aptreminder';
import myaccount from './myaccount';
import urlredirect from './urlredirect';
import practicepulse from './practicepulse';
//import supabase from './supabase';
import moolah from './moolah';
import cache from './cache';
import kanban from './kanban';
import calendar from './modules/calendar';
import botAdmin from './modules/botAdmin';
import a2p from './a2p';
import slack from './slack';
import plaid from './plaid';
import campaigns from './campaigns';
import emailReports from './emailReports';
import onlineAppointments from './onlineAppointments';
import bookingRedirect from './bookingRedirect';
import campaignTrackRedirect from './campaignTrackRedirect';
import nudges from './nudges';
import txPresenter from './txPresenter';
import insuranceVerification from './insuranceVerification';
import wallet from './wallet';
import reviewLanding from './reviewLanding';
import reviews from './reviews';
import patientPhoto from './patientPhoto';
import scheduleView from './scheduleView';
import patientPanel from './patientPanel';


const fb = require('./firebase.config.js');

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

let logrocketPlugin = createPlugin(LogRocket);

Vue.use(Vuex);

const state = {
  firebase: fb.firebase,
  db: fb.db,
  GoogleAuthProvider: fb.GoogleAuthProvider,
  signInWithPopup: fb.signInWithPopup,  
  getAuth: fb.getAuth,
  collection: fb.collection,
  query: fb.query,
  where: fb.where,
  orderBy: fb.orderBy,
  limit: fb.limit,
  onSnapshot: fb.onSnapshot,
  getDocs: fb.getDocs,
  deleteDoc: fb.deleteDoc,
  doc: fb.doc,
  getDoc: fb.getDoc,
  setDoc: fb.setDoc,
  signOut: fb.signOut
}

export default new Vuex.Store({
  state,
  modules: {
    layout, customer, tasks, lists, alert, filters, teamio, wiki, notifications, chat, checklists,
    routines, superadmin, workflow, huddle, conversationsV2, taskNotifications, forms, aptreminder, myaccount, urlredirect,
    practicepulse, moolah, cache, kanban, calendar, botAdmin, a2p, slack, plaid, campaigns, emailReports,
    onlineAppointments, bookingRedirect, campaignTrackRedirect, nudges, txPresenter, insuranceVerification, wallet, reviewLanding, reviews,
    patientPhoto, scheduleView, patientPanel
  },
  plugins: [logrocketPlugin]
});
